const getters = {
    purchaseorders: (state) => state.purchaseorders,
    purchaseorderId: (state) =>state.purchaseorderId,
    loading: state => state.loading,
    documents: (state) => state.documents,
    file: state => state.file,
    docLoader: state => state.docLoader,
};

export default getters;